// Flow types automatically removed

export const FULL_ARCHITECTURE_DESIGN = 'fullArchitectureDesign';
export const FULL_HOUSE_DESIGN = 'fullHouseDesign';
export const DESIGN_COUPLE_ROOMS = 'designCoupleRooms';
export const DESIGN_SINGLE_ROOM = 'designSingleRoom';
export const HELP_SINGLE_ITEM = 'helpSingleItem';
